import { useContext } from "react";
import { AuthContext } from "../../services/context";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useGetSponsorLevels } from "../../api/sponsors";
import SponsorForm from "./SponsorForm";
import { useGetEvent } from "../../api/event";

function CreateSponsor() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);

  const { data: sponsorLevels } = useGetSponsorLevels({
    eventId: currentWorkspace?.eventId,
  });

  const { data: event } = useGetEvent(currentWorkspace?.eventId);

  return (
    <SponsorForm
      mode="create"
      sponsorLevels={sponsorLevels || []}
      event={event}
    />
  );
}

export default CreateSponsor;
